import { Theme } from "@mui/material";
import { alpha } from "@mui/system";

const useStyles = (theme: Theme, open?: Boolean) => ({
  boxContainer: {
    minHeight: "40px",
    height: "fit-content",
    width: { xs: "100%", sm: "fit-content" },
  },
  boxInputSelect: {
    width: "100%",
    maxWidth: "fit-content",
    position: "relative",
    minHeight: "40px",
    height: "fit-content",
    borderRadius: "8px",
    paddingX: 1,
    paddingY: open ? 1 : 0,
    gap: 1,
    cursor: "pointer",
    display: "flex",
    alignItems: open ? "start" : "center",
    justifyContent: "space-between",
    flexWrap: "nowrap" as const,
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
    "&:hover": {
      backgroundColor: alpha(theme.palette.background.textField, 0.5),
    },
    "&.focused": {},
  },
  input: {
    color: theme.palette.background.paper,
    cursor: "pointer",
    height: "0px",
    backgroundColor: "transparent",
    boxSizing: "border-box",
    padding: "4px 6px",
    width: "0px",
    display: "none",
    flexGrow: 1,
    border: 0,
    margin: 0,
    outline: 0,
  },
  boxTags: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 0.5,
    maxHeight: open ? "120px" : "40px",
    overflowY: "hidden",
    overflowX: "hidden",
    justifyContent: "start",
    alignItems: "start",
    paddingY: open ? 0 : 1,
  },
  label: {
    fontWeight: "bold",
    color: "text.secondary",
    fontSize: "0.875rem",
    //width: "40px",
    height: "100%",
  },
  divTag: (onDelete: boolean) => ({
    display: "flex",
    alignItems: "center",
    height: "fit-content",
    lineHeight: "22px",
    borderRadius: "6px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.textField,
    boxSizing: "content-box",
    padding: onDelete ? "0 4px 0 10px" : "0 10px 0 10px",
    outline: 0,
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "capitalize",
    maxWidth: "150px",
    width: "fit-content",
    zIndex: 3,
  }),
  textTag: {
    color: theme.palette.text.primary,
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "capitalize",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "fit-content",
    maxWidth: "100px",
    textOverflow: "ellipsis",
  },
  closeIcon: {
    color: "text.secondary",
    fontWeight: "bold",
    fontSize: "16px",
    cursor: "pointer",
    //width: "fit-content",
    //padding: "4px",
    zIndex: 3,
  },
  menu: (listBoxWidth: number) => ({
    "& .MuiList-root ": {
      // width: { xs: listBoxWidth, sm: listBoxWidth },
      // width: { xs: listBoxWidth, sm: "fit-content" },
      width: listBoxWidth,
      minWidth: "100px",
      maxHeight: "300px",
      overflowY: "auto",
      p: 0,
    },
    "& .MuiPaper-root.MuiPopover-paper.MuiMenu-paper ": {
      marginTop: "5px",
      borderRadius: 1,
      boxShadow: "0px 4px 14px 0px  #0000002c",
    },
  }),
  menuItem: (isSelected: boolean, disabled: boolean) => ({
    cursor: "pointer",
    padding: "6px 12px",
    display: "flex",
    borderRadius: 1,
    gap: 1.5,
    margin: "4px",
    //width: "100%",
    color: disabled
      ? theme.palette.text.disabled
      : isSelected
      ? theme.palette.text.primary
      : theme.palette.text.secondary,
    backgroundColor: isSelected
      ? alpha(theme.palette.background.textField, 0.3)
      : "transparent",
    "&:hover": {
      backgroundColor: disabled
        ? "transparent"
        : isSelected
        ? alpha(theme.palette.primary.main, 0.1)
        : alpha(theme.palette.background.textField, 0.5),
    },
  }),
  menuItemSelectAll: (disabled: boolean) => ({
    justifyContent: "left",
    width: "calc(100% - 0.5rem)",
    // width: "fit-content",
    padding: "6px 12px",
    display: "flex",
    fontSize: "1rem",
    borderRadius: 1,
    gap: 1,
    margin: "4px",
    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    "&:focused": {
      backgroundColor: "transparent",
    },
    "&:hover": {
      backgroundColor: disabled
        ? "transparent"
        : alpha(theme.palette.primary.main, 0.1),
      color: disabled
        ? theme.palette.text.disabled
        : theme.palette.primary.main,
    },
  }),
});

export default useStyles;
